import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/arrow.png'


const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = { class: "city" }
const _hoisted_3 = { class: "bus-info" }
const _hoisted_4 = { class: "bus-list" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "search-keyboard" }
const _hoisted_7 = { class: "keyboard" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_HeaderBar = _resolveComponent("HeaderBar")!
  const _component_BusInfoCard = _resolveComponent("BusInfoCard")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_component_BaseLayout, null, {
      header: _withCtx(() => [
        _createVNode(_component_HeaderBar),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.currentCity), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "搜尋公車號",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchInput) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchInput]
          ])
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("article", _hoisted_4, [
            (_ctx.busRoutes.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.busRoutes, (routeInfo) => {
                  return (_openBlock(), _createBlock(_component_BusInfoCard, {
                    key: routeInfo.RouteUID,
                    routeInfo: routeInfo,
                    onClick: ($event: any) => (_ctx.$router.push(`${_ctx.city}/${routeInfo.RouteName?.Zh_tw}`))
                  }, null, 8, ["routeInfo", "onClick"]))
                }), 128))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, "未查詢到相關公車路線！"))
          ]),
          _createElementVNode("article", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "keyboard__item red",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.keyInMiniKeyboard('紅')))
              }, "紅"),
              _createElementVNode("div", {
                class: "keyboard__item blue",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.keyInMiniKeyboard('藍')))
              }, "藍"),
              _createElementVNode("div", {
                class: "keyboard__item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.keyInMiniKeyboard('1')))
              }, "1"),
              _createElementVNode("div", {
                class: "keyboard__item",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.keyInMiniKeyboard('2')))
              }, "2"),
              _createElementVNode("div", {
                class: "keyboard__item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.keyInMiniKeyboard('3')))
              }, "3"),
              _createElementVNode("div", {
                class: "keyboard__item green",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.keyInMiniKeyboard('綠')))
              }, "綠"),
              _createElementVNode("div", {
                class: "keyboard__item brown",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.keyInMiniKeyboard('棕')))
              }, "棕"),
              _createElementVNode("div", {
                class: "keyboard__item middle-row-item",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.keyInMiniKeyboard('4')))
              }, "4"),
              _createElementVNode("div", {
                class: "keyboard__item middle-row-item",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.keyInMiniKeyboard('5')))
              }, "5"),
              _createElementVNode("div", {
                class: "keyboard__item middle-row-item",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.keyInMiniKeyboard('6')))
              }, "6"),
              _createElementVNode("div", {
                class: "keyboard__item orange",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.keyInMiniKeyboard('橘')))
              }, "橘"),
              _createElementVNode("div", {
                class: "keyboard__item small",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.keyInMiniKeyboard('小')))
              }, "小"),
              _createElementVNode("div", {
                class: "keyboard__item",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.keyInMiniKeyboard('7')))
              }, "7"),
              _createElementVNode("div", {
                class: "keyboard__item",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.keyInMiniKeyboard('8')))
              }, "8"),
              _createElementVNode("div", {
                class: "keyboard__item",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.keyInMiniKeyboard('9')))
              }, "9"),
              _createElementVNode("div", {
                class: "keyboard__item",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.keyInMiniKeyboard('其他')))
              }, "其他"),
              _createElementVNode("div", {
                class: "keyboard__item",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.keyInMiniKeyboard('幹線')))
              }, "幹線"),
              _createElementVNode("div", {
                class: "keyboard__item zero",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.keyInMiniKeyboard('0')))
              }, "0"),
              _createElementVNode("div", {
                class: "keyboard__item clear",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args)))
              }, "清除")
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}